import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from '@/modules/core/services/table-utils';

const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/display/workload/statistic';
const serviceName = "Workload-Service: ";
const sortTableFields = ["name", "active"];
const sortDatabaseFields = ["name","active"];

export default class WorkloadService {

  static async getStatistics(paginator, filter, successF, errorF) {
    let params = createPageableParams(paginator.page,
      paginator.size,
      paginator.search,
      [paginator.sort],
      paginator.sortAsc,
      successF,
      errorF,
      sortTableFields,
      sortDatabaseFields);

    await WrapperService.post(API_URL + '?' + params, filter, serviceName, successF, errorF);
  }

  static async getStatisticChart(statisticId, successF, errorF) {
    await WrapperService.get(API_URL + '/' + statisticId, null, serviceName, successF, errorF);
  }

}